import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Overlay from "../../Overlay";
import { Form, Formik } from "formik";
import TextBox from "../../common/TextBox";
import "../../../styles/profile.scss";
import Button from "../../common/Button";
import useUsers from "../../../hooks/useUsers";
import AppContext from "../../../AppContext";
import { toast } from "react-toastify";
import ComboBox from "../../common/ComboBox";
import _ from "lodash";

const AddUser = ({ userId, onClose }) => {
  const { user } = useContext(AppContext);
  const { createUser, getUser, patchUser } = useUsers();
  const [roles, setRoles] = useState(undefined);
  const { queryRoles, queryUsers } = useUsers();
  const [initialValues, setInitialValues] = useState(undefined);

  useEffect(() => {
    if (!userId) return;

    getUser(userId).then(({ firstname, surname, email, roles }) => {
      setInitialValues({
        firstname,
        surname,
        email,
        role: roles[0],
      });
    });
  }, [userId]);

  useEffect(() => {
    // * Get roles
    queryRoles(
      {
        staff: false,
        name: {
          $ne: "Owner",
        },
      },
      null,
      -1
    ).then(({ data }) => {
      setRoles(
        data.map((d) => ({
          name: d.name,
          value: d._id,
        }))
      );
    });
  }, []);

  const handleValidate = ({ firstname, surname, email, password, role }) => {
    let errors = {};

    if (!firstname) errors.firstname = "Cannot leave blank";
    if (!surname) errors.surname = "Cannot leave blank";
    if (!email) errors.email = "Cannot leave blank";
    if (!userId && !password) errors.password = "Cannot leave blank";
    if (!role) errors.role = "Please select a role";

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Enter a valid email";
    }

    return errors;
  };

  const handleSubmit = async (
    { firstname, surname, email, password, role },
    { setSubmitting }
  ) => {
    try {
      // * Edit user instead
      if (userId) {
        await patchUser(userId, {
          roles: [role],
        });

        onClose();
        return;
      }

      // * Check if email already exists
      const { data: exist } = await queryUsers(
        { email, deleted: false },
        1,
        1,
        { _id: 1 }
      );

      if (exist.length > 0) {
        // * Email already in use
        toast.error("Email already registered");
        return;
      }

      await createUser({
        firstname,
        surname,
        email,
        password,
        plan: user.plan,
        company: user.company,
        status: 2,
        roles: [role],
      });

      toast.success("Invited user");

      onClose();
    } catch (error) {
      console.error(error.message);
      setSubmitting(false);
    }
  };

  if (userId && !initialValues) {
    return "";
  }

  return (
    <Overlay
      onClose={onClose}
      content={
        <>
          <h2 className="company-new-user__title">
            {userId ? "Edit user" : "Add new user"}
          </h2>
          <Formik
            initialValues={
              initialValues ?? {
                firstname: "",
                surname: "",
                email: "",
                password: "",
              }
            }
            validate={handleValidate}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            <Form className="company-new-user">
              <TextBox
                name="firstname"
                placeholder="Firstname"
                type="text"
                label="Firstname"
              />
              <TextBox
                name="surname"
                placeholder="Surname"
                type="text"
                label="Surname"
              />
              <div style={{ gridColumn: "1 / 3" }}>
                <TextBox
                  name="email"
                  placeholder="Email"
                  type="text"
                  label="Email"
                />
              </div>
              {!userId && (
                <div style={{ gridColumn: "1 / 3" }}>
                  <TextBox
                    name="password"
                    placeholder="Password"
                    type="text"
                    label="Password"
                  />
                </div>
              )}
              <div style={{ gridColumn: "1 / 3" }}>
                {roles && (
                  <ComboBox
                    name={"role"}
                    options={roles}
                    label={"Role"}
                    placeholder={"Select role"}
                  />
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gridColumn: "1 / 3",
                  marginTop: 24,
                }}
              >
                <Button label={userId ? "Save" : "Invite user"} type="submit" />
              </div>
            </Form>
          </Formik>
        </>
      }
    />
  );
};

AddUser.propTypes = {};

export default AddUser;
